import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Función para formatear moneda
function formatCurrency(value) {
  if (value === null || value === undefined) return 'RD$0.00';
  let numValue;
  if (typeof value === 'string') {
    numValue = parseFloat(value.replace(/,/g, ''));
  } else if (typeof value === 'number') {
    numValue = value;
  } else {
    return 'RD$0.00';
  }
  return numValue.toLocaleString('es-DO', {
    style: 'currency',
    currency: 'DOP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

// Función para agregar pie de página con numeración
function addFooter(doc, currentPage, totalPages) {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 15;
  const footerY = pageHeight - 25;
  
  doc.setDrawColor(139, 69, 19);
  doc.setLineWidth(0.5);
  doc.line(margin, footerY, pageWidth - margin, footerY);
  
  doc.setFontSize(7);
  doc.setFont('helvetica', 'italic');
  doc.setTextColor(100, 100, 100);
  doc.text('Este documento ha sido generado electrónicamente y es válido sin firma autógrafa (Versión de Práctica).', margin, footerY + 5);
  
  doc.text(`Generado el: ${new Date().toLocaleString('es-DO')}`, margin, footerY + 10);
  
  // Texto centrado del pie
  const footerText = "D'Princess Foto Films (Práctica) - Capturando momentos únicos";
  const footerWidth = doc.getTextWidth(footerText);
  doc.text(footerText, (pageWidth - footerWidth) / 2, footerY + 15);
  
  // Número de página en el borde inferior derecho
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(80, 80, 80);
  const pageText = `Página ${currentPage} / ${totalPages}`;
  const pageTextWidth = doc.getTextWidth(pageText);
  doc.text(pageText, pageWidth - margin - pageTextWidth, footerY + 15);
}

// Función principal para generar PDF de nota de crédito
export const generateCreditNotePDF = (creditNoteData, invoiceData, creditNoteDetails) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 15;
  let yPosition = 15;
  let currentPage = 1;

  // Configurar fuentes
  doc.setFont('helvetica');

  // ENCABEZADO PRINCIPAL (más compacto)
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 69, 19);
  doc.text("D'Princess Foto Films (Práctica)", margin, yPosition);
  
  yPosition += 6;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text('Servicios Profesionales de Fotografía y Video (Versión de Práctica)', margin, yPosition);
  
  yPosition += 4;
  doc.setFontSize(8);
  doc.text('Tel.: (809) 708-5336 • Email: info@dprincess.com (Práctica)', margin, yPosition);
  
  // TÍTULO DEL DOCUMENTO
  yPosition += 12;
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(220, 20, 60);
  const titleText = 'NOTA DE CRÉDITO (PRÁCTICA)';
  const titleWidth = doc.getTextWidth(titleText);
  doc.text(titleText, (pageWidth - titleWidth) / 2, yPosition);
  
  // Número de nota de crédito
  yPosition += 6;
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  const numberText = `No. ${creditNoteData.creditNoteNumber}`;
  const numberWidth = doc.getTextWidth(numberText);
  doc.text(numberText, (pageWidth - numberWidth) / 2, yPosition);
  
  // Línea decorativa
  yPosition += 4;
  doc.setDrawColor(220, 20, 60);
  doc.setLineWidth(0.5);
  doc.line(margin, yPosition, pageWidth - margin, yPosition);
  
  // INFORMACIÓN DE LA EMPRESA Y CLIENTE (más compacta)
  yPosition += 10;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  
  // Columna izquierda - Datos de la empresa
  const leftColumnData = [
    'DATOS DE LA EMPRESA (PRÁCTICA):',
    'D\'Princess Foto Films (Práctica)'
  ];
  
  // Columna derecha - Datos del cliente
  const rightColumnData = [
    'DATOS DEL CLIENTE (Falso):',
    `Cliente: ${invoiceData.clientName || 'No registrado'} (Práctica)`,
  ];
  
  const rightColumnX = pageWidth / 2 + 5;
  
  // Renderiza ambas columnas
  for (let i = 0; i < Math.max(leftColumnData.length, rightColumnData.length); i++) {
    doc.setFont('helvetica', i === 0 ? 'bold' : 'normal');
    if (leftColumnData[i]) {
      doc.text(leftColumnData[i], margin, yPosition);
    }
    if (rightColumnData[i]) {
      doc.text(rightColumnData[i], rightColumnX, yPosition);
    }
    yPosition += 4;
  }
  
  // INFORMACIÓN DE LA NOTA DE CRÉDITO
  yPosition += 8;
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 69, 19);
  doc.text('INFORMACIÓN DE LA NOTA DE CRÉDITO (PRÁCTICA)', margin, yPosition);
  
  yPosition += 6;
  
  // Tabla de información básica (más compacta)
  const infoData = [
    ['Factura relacionada:', invoiceData.invoiceNumber],
    ['Motivo general:', creditNoteData.reason],
    ['Estado de la nota:', creditNoteData.paymentStatus === 'pendiente' ? 'Pendiente de aplicación' : 'Aplicada']
  ];
  
  autoTable(doc, {
    startY: yPosition,
    body: infoData,
    theme: 'plain',
    styles: {
      fontSize: 9,
      cellPadding: 2,
    },
    columnStyles: {
      0: { fontStyle: 'bold', cellWidth: 45 },
      1: { cellWidth: 80 }
    },
    margin: { left: margin, right: margin }
  });
  
  // DETALLES DE LOS SERVICIOS AFECTADOS
  yPosition = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 69, 19);
  doc.text('DETALLES DE SERVICIOS AFECTADOS (PRÁCTICA)', margin, yPosition);
  
  // Preparar datos para la tabla de servicios
  const servicesTableData = [];
  let totalAcreditado = 0;
  
  creditNoteDetails.forEach((detail, index) => {
    const serviceInfo = invoiceData.invoiceDetails.find(
      service => service.selectedServiceID === detail.selectedServiceID
    );
    
    if (serviceInfo) {
      servicesTableData.push([
        index + 1,
        serviceInfo.serviceName,
        serviceInfo.serviceQty.toString(),
        formatCurrency(parseFloat(serviceInfo.servicePrice.replace(/,/g, ''))),
        formatCurrency(parseFloat(serviceInfo.servicePrice.replace(/,/g, '')) * serviceInfo.serviceQty),
        detail.concept,
        formatCurrency(detail.amount),
        detail.paymentStatus === "pendiente" ? 'Pendiente' : 'Aplicado'
      ]);
      totalAcreditado += detail.amount;
    }
  });
  
  // Tabla de servicios (optimizada)
  autoTable(doc, {
    startY: yPosition + 5,
    head: [['#', 'Servicio', 'Cant.', 'Precio Unit.', 'Total Facturado', 'Motivo', 'Monto Acreditado', 'Estado del Crédito']],
    body: servicesTableData,
    theme: 'striped',
    headStyles: {
      fillColor: [139, 69, 19],
      textColor: 255,
      fontStyle: 'bold',
      fontSize: 8
    },
    styles: {
      fontSize: 7,
      cellPadding: 2,
    },
    columnStyles: {
      0: { cellWidth: 8, halign: 'center' },
      1: { cellWidth: 35 },
      2: { cellWidth: 12, halign: 'center' },
      3: { cellWidth: 22, halign: 'right' },
      4: { cellWidth: 22, halign: 'right' },
      5: { cellWidth: 30 },
      6: { cellWidth: 22, halign: 'right', fontStyle: 'bold' }
    },
    margin: { left: margin, right: margin }
  });
  
  // TOTALES (más compacto)
  yPosition = doc.lastAutoTable.finalY + 8;
  
  // Recuadro de totales
  const totalBoxWidth = 55;
  const totalBoxHeight = 20;
  const totalBoxX = pageWidth - margin - totalBoxWidth;
  
  doc.setFillColor(245, 245, 245);
  doc.rect(totalBoxX, yPosition, totalBoxWidth, totalBoxHeight, 'F');
  doc.setDrawColor(139, 69, 19);
  doc.setLineWidth(1);
  doc.rect(totalBoxX, yPosition, totalBoxWidth, totalBoxHeight);
  
  // Texto de totales
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 69, 19);
  doc.text('TOTAL A ACREDITAR (PRÁCTICA):', totalBoxX + 2, yPosition + 7);
  
  doc.setFontSize(12);
  doc.setTextColor(220, 20, 60);
  const totalText = formatCurrency(creditNoteData.amount);
  const totalTextWidth = doc.getTextWidth(totalText);
  doc.text(totalText, totalBoxX + (totalBoxWidth - totalTextWidth) / 2, yPosition + 15);
  
  // Verificar espacio disponible para condiciones
  yPosition += 25;
  const spaceLeft = pageHeight - yPosition - 40; // Reservar 40mm para pie de página
  
  if (spaceLeft < 30) { // Si no hay suficiente espacio, nueva página
    doc.addPage();
    currentPage++;
    yPosition = 20;
  }
  
  // CONDICIONES Y OBSERVACIONES (optimizadas)
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text('CONDICIONES (PRÁCTICA):', margin, yPosition);
  
  yPosition += 6;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  const conditions = [
    '• Esta información es ficticia y se utiliza únicamente con fines prácticos. No representa datos reales.',
    '• Versión de Práctica - Rama Practica.',
  ];
  
  conditions.forEach(condition => {
    // Verificar si hay espacio para la línea
    if (yPosition > pageHeight - 35) {
      doc.addPage();
      currentPage++;
      yPosition = 20;
    }
    doc.text(condition, margin, yPosition);
    yPosition += 4;
  });
  
  // Obtener el número total de páginas
  const totalPages = doc.internal.getNumberOfPages();
  
  // Agregar pie de página a todas las páginas
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    addFooter(doc, i, totalPages);
  }
  
  return doc;
};